var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "diaryMenuHeader-wapper", attrs: { align: "center" } },
    [
      _c(
        "column-wrapper",
        [
          _c("first-course", {
            attrs: { edit: true, title: "1er Plato" },
            on: { updatedElement: _vm.detectElementChange }
          }),
          _vm._v(" "),
          _c("h3", { staticClass: "text-center" }, [_vm._v("Primer Plato")])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "column-wrapper",
        [
          _c("second-course", {
            attrs: { edit: true, title: "2º Plato" },
            on: { updatedElement: _vm.detectElementChange }
          }),
          _vm._v(" "),
          _c("h3", { staticClass: "text-center" }, [_vm._v("Segundo Plato")])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "column-wrapper",
        [
          _c("desserts", {
            attrs: { edit: true, title: "Postre" },
            on: { updatedElement: _vm.detectElementChange }
          }),
          _vm._v(" "),
          _c("h3", { staticClass: "text-center" }, [_vm._v("Postre")])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "column-wrapper",
        [
          _c("suggested-dinner", {
            attrs: { edit: true, title: "Cena Sugerida" },
            on: { updatedElement: _vm.detectElementChange }
          }),
          _vm._v(" "),
          _c("h3", { staticClass: "text-center" }, [_vm._v("Cena Sugerida")])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7804dcd4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7804dcd4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/diaryType/MenuDiary/MenuDiaryHeader.vue
// module id = 287
// module chunks = 1